// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_edaa115","toggle":"_36f9bbe","label":"_fa0e2cd"};